import React, { FC, useMemo } from 'react';
import { FormatterProps } from '../../../types';
import GovernanceTagsPopover from '../TagsPopover';
import apiConstants from 'shared/api/apiConstants';

import styles from '../GovernanceTagsTableController.module.scss';

interface Tag {
  name: string;
  value: string;
}

interface UnifiedTagsFormatterProps extends FormatterProps {
  tagField: 'tags' | 'governanceTags';
}

const UnifiedTagsFormatter: FC<UnifiedTagsFormatterProps> = ({ row, tagField }) => {
  const { visibleTags, hiddenTags, allTags } = useMemo(() => {
    let tagsArray: Tag[] = [];

    if (tagField === apiConstants.QUERY_KEYS.GOVERNANCE_TAGS) {
      if (!row?.governanceTags?.length) {
        return { visibleTags: [], hiddenTags: [], allTags: [] };
      }
      tagsArray = row.governanceTags;
    } else {
      if (!row?.tags || typeof row.tags !== 'object' || Object.keys(row.tags).length === 0) {
        return { visibleTags: [], hiddenTags: [], allTags: [] };
      }
      tagsArray = Object.entries(row.tags).map(([name, value]) => ({ name, value }));
    }

    const displayLimit = tagsArray.length > 3 ? 2 : tagsArray.length;
    return {
      visibleTags: tagsArray.slice(0, displayLimit),
      hiddenTags: tagsArray.slice(displayLimit),
      allTags: tagsArray,
    };
  }, [row?.tags, row?.governanceTags, tagField]);

  if (allTags.length === 0) {
    return null;
  }

  return (
    <div className={styles.virtualTagsContainer}>
      {visibleTags.map((tag) => (
        <div key={`${tag.name}-${tag.value}`} className={styles.tagEntry}>
          {tag.name}: {tag.value}
        </div>
      ))}
      {hiddenTags.length > 0 && (
        <GovernanceTagsPopover tags={allTags}>
          <div className={styles.moreTagsIndicator}>+ {hiddenTags.length} more</div>
        </GovernanceTagsPopover>
      )}
    </div>
  );
};

export default UnifiedTagsFormatter;
